import * as z from "zod";

const attachmentSchema = z.object({
  url: z.string(),
  description: z.string(),
  mimeType: z.string(),
});

export const submitContactForm = {
  name: "submitContactForm" as const,
  input: z.object({
    name: z.string().optional(),
    email: z.string().email(),
    subject: z.string().optional(),
    phone: z.string().optional(),
    comment: z.string(),
    attachments: z.array(attachmentSchema).optional(),
    customFields: z.record(z.string(), z.string()).optional(),
  }),
  output: z.object({ conversationId: z.string() }),
};
